__turbopack_context__.v({
  "attribution": "object-basics-module-scss-module__Nqcq8G__attribution",
  "content": "object-basics-module-scss-module__Nqcq8G__content",
  "image": "object-basics-module-scss-module__Nqcq8G__image",
  "imageWrapper": "object-basics-module-scss-module__Nqcq8G__imageWrapper",
  "noImage": "object-basics-module-scss-module__Nqcq8G__noImage",
  "restricted": "object-basics-module-scss-module__Nqcq8G__restricted",
  "text": "object-basics-module-scss-module__Nqcq8G__text",
  "textWrapper": "object-basics-module-scss-module__Nqcq8G__textWrapper",
});
